import { getQaSelector } from '../../../../utils/common'
import { Skeleton } from '../../../Skeleton'

import {
  GRETA_AI_CHAT_PROJECTS_SKELETON_WIDTHS,
  QA_NAME_GRETA_AI_CHAT_PROJECTS_SKELETON,
} from './GretaAIChatChatListProjectsSkeleton.constants'

import * as styles from './GretaAIChatChatListProjectsSkeleton.module.css'

function GretaAIChatChatListProjectsSkeleton() {
  return (
    <div
      {...getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_PROJECTS_SKELETON })}
      aria-hidden
      className={styles.skeleton}
    >
      {GRETA_AI_CHAT_PROJECTS_SKELETON_WIDTHS.map(width => (
        <Skeleton className={styles.row} key={width} style={{ width }} />
      ))}
    </div>
  )
}

export default GretaAIChatChatListProjectsSkeleton
